<template>
  <v-menu activator="parent" submenu>
    <v-list class="childrenMenu">
      <v-list-item v-for="route in routes">
        <RouterLink
          class="actionLink intec-blue--text"
          :class="{ currentAction: isCurrentPage(route.path) }"
          :to="route.children ? '' : route.path"
        >
          <v-list-item-title>{{ route.name }}</v-list-item-title>

        </RouterLink>
        <template v-if="route.children" v-slot:append>
          <v-icon icon="mdi-menu-right" size="x-small"></v-icon>
        </template>
        <children-menu-item v-if="route.children" :routes="route.children"/>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import {useRoute} from "vue-router";

const { routes } = defineProps({
  routes: Array
})
const currentRoute = useRoute()
const isCurrentPage = path => currentRoute.path.includes(path);

</script>

<style scoped>
.menu-blue--text {
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
}

.childrenMenu {
  color: rgb(var(--gold-color)) !important;
  background: rgb(var(--primary-color)) !important;
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(var(--gold-color), 0.2)),
  0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(var(--gold-color), 0.14)),
  0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(var(--gold-color), 0.12)) !important;
}

.actionLink {
  text-decoration: none;
  color: rgb(var(--gold-color)) !important;
  background: rgb(var(--primary-color)) !important;
}

.appbar-admin-btn :deep(.v-btn__overlay) {
  background-color: transparent;
}

.appbar-admin-btn :deep(.v-btn__content) {
  color: rgb(var(--gold-color)) !important;
}

.appbar-admin-btn :deep(v-ripple__container) {
  color: #00FF00;
}

.appbar-menu-admin-btn {
  background-color: rgb(var(--primary-color)) !important;
  width: 210px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
  border-radius: 8px;
  box-shadow: 0px 1px 3px 0px #00000026;
}

.appbar-menu-admin-btn :deep(.v-btn__content) {
  padding: 10px 12.5px;
  font-size: 16px;
  font-weight: 500;
  color: rgb(var(--gold-color)) !important;
}

.currentAction {
  text-decoration-line: underline;
  text-underline-offset: 5px;
}
</style>